import React, { useEffect, useState } from 'react';
import MinimalFooter from '../../components/MinimalFooter';
import MixerPortalNavBar from './Color Mixer UI Components/MixerPortalNavBar'
import SuccessMatchHeader from './Color Mixer UI Components/SuccessMatchHeader';
import MixerAvatarRow from './Color Mixer UI Components/MixerAvatarRow';

// ✅ Helper (exactly like PostMatchPage)
function getProfilePicUrl(userObj) {
  return userObj?.profilePicUrl || '/default-avatar.png';
}

export default function MatchingSuccess({
  yourName,             // 👈 accept from parent (Portal)
  partnerName,
  partnerPic,
  yourPic,
  endsAt,
}) {
  const [countdown, setCountdown] = useState('--:--');

  // Fallback only if prop is missing
  const resolvedYourName =
    (yourName && String(yourName).trim()) ||
    (localStorage.getItem('firstName') || 'You');

  const partnerClean = (partnerPic && String(partnerPic).trim()) || '/default-avatar.png';
  const yourClean =
    (yourPic && String(yourPic).trim()) ||
    (localStorage.getItem('profilePicUrl') && String(localStorage.getItem('profilePicUrl')).trim()) ||
    '/default-avatar.png';

  useEffect(() => {
    const timer = setInterval(() => {
      const diff = new Date(endsAt) - new Date();
      if (diff <= 0) {
        clearInterval(timer);
      } else {
        const minutes = String(Math.floor(diff / 60000)).padStart(2, '0');
        const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
        setCountdown(`${minutes}:${seconds}`);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [endsAt]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      fontFamily: "'Open Sans', sans-serif",
    }}>
      <div style={{ flex: 1, maxWidth: '500px', width: '100%', margin: '0 auto', textAlign: 'center' }}>
        <MixerPortalNavBar />

        <SuccessMatchHeader
          yourName={resolvedYourName}   // 👈 pass the resolved name
          partnerName={partnerName}
          endsAt={endsAt}
        />

        <MixerAvatarRow
          yourName={resolvedYourName}   // 👈 pass the resolved name
          partnerName={partnerName}
          yourPic={yourClean}
          partnerPic={partnerClean}
        />
      </div>

      <MinimalFooter />
    </div>
  );
}
